import { Platform, NativeModules } from 'react-native';
import isInKwaiying from '../isInKwaiying';
// import setCurrentPageV2 from '../setCurrentPageV2';
import setCurrentPage from '../setCurrentPage';
import { numberToString } from '../utils';
// dau统计会使用该字段，所以快影端内使用KUAISHOU_VIDEO_EDITOR，非快影端内用KUAISHOU_VIDEO_EDITOR_WEB
export const product = isInKwaiying()
    ? 'KUAISHOU_VIDEO_EDITOR'
    : 'KUAISHOU_VIDEO_EDITOR_WEB';
export const radarId = Platform.select({
    web: '419b038523',
    default: '0dc1668902',
});
function getCustomFailed(data) {
    if (typeof data?.result === 'number') {
        return data.result === 11;
    }
    if (typeof data?.status === 'number') {
        return data.status !== 0;
    }
}
export const radarOptions = {
    projectId: radarId,
    sampling: 0.9,
    APIHook(apiData) {
        const { response } = apiData;
        let data = {};
        try {
            data = JSON.parse(response.data);
        }
        catch (e) {
            // do nothing
        }
        return {
            response_code: data.result || data.status,
            response_msg: data.errMsg || data.msg || data.message,
            status: response.status,
            custom_failed: getCustomFailed(data),
        };
    },
};
export const hasLogByBridge = (type, pageOrAction = '', params = {}, extra = {}, pageName = '', pageParams = {}) => {
    if (!isInKwaiying()) {
        return false;
    }
    // 使用sdk一堆问题，先不用
    // if (canUseBridge('setCurrentPageV2')) {
    //     if (
    //         type === 'PV' &&
    //         (extra?.type === 'enter' || extra?.type === 'visible')
    //     ) {
    //         setCurrentPageV2(pageOrAction);
    //     }
    //     return false;
    // } else
    if (Platform.OS !== 'web') {
        if (type === 'PV') {
            // 如何手动触发leave事件，目前看是客户端处理的，跳去其他页面会触发leave
            if (extra?.type === 'enter' || extra?.type === 'visible') {
                setCurrentPage(pageOrAction, extra?.type === 'enter', params);
            }
        }
        else {
            // 上传埋点，不用callNative，防止循环调用
            NativeModules?.Kwaiying?.uploadAnalytics &&
                NativeModules.Kwaiying.uploadAnalytics({
                    arguments: {
                        id: pageOrAction,
                        params: numberToString(params),
                        pageName: extra?.urlPage?.page || pageName,
                        pageParams: numberToString(pageParams),
                        elementType: type.toLowerCase(),
                    },
                }, () => { });
        }
        return true;
    }
    return false;
};
